<template>
    <div class="w-lg-500px bg-white rounded shadow-sm px-10 pb-10 px-lg-15 pb-lg-15 mx-auto">
        <Form class="form w-100" id="kt_login_signin_form" @submit="onSubmitLogin" :validation-schema="login">
            <div class="cdr-ribbon"></div>
            <div class="login-container">
                <a href="#">
                    <img alt="Logo" src="/media/logos/logoCDR.svg" class="cdr-logo mb-12" />
                </a>
                <div class="login-header">
                    <h3 class="text-primary text-uppercase fw-boldest fs-1">Members</h3>
                    <h3 class="text-primary text-uppercase fw-lighter fs-1">Administration</h3>
                </div>
            </div>

            <div class="mb-5">
                <h1 class="text-primary mt-15 fw-boldest">Sign in</h1>
            </div>

            <div class="fv-row mb-10">
                <label class="form-label fs-4 text-muted">Email Address</label>
                <Field class="form-control form-control-lg form-control-solid" type="text" name="email" autocomplete="off" />
                <div class="fv-plugins-message-container">
                    <div class="fv-help-block">
                        <ErrorMessage name="email" />
                    </div>
                </div>
            </div>

            <div class="fv-row mb-10">
                <div class="d-flex flex-stack mb-2">
                    <label class="form-label text-muted fs-4 mb-0">Password</label>
                </div>
                <Field class="form-control form-control-lg form-control-solid mb-2" type="password" name="password" autocomplete="off" />
                <p @click="redirectChangePassword()" role="button" class="text-muted fs-6 m-0">Forgot Password ?</p>
                <div class="fv-plugins-message-container">
                    <div class="fv-help-block">
                        <ErrorMessage name="password" />
                    </div>
                </div>
            </div>

            <div class="text-center">
                <button type="submit" ref="submitButton" id="kt_sign_in_submit" class="btn btn-lg btn-primary w-100 mb-5">
                    <span class="indicator-label"> Sign In </span>
                    <span class="indicator-progress">
                        Please wait...
                        <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>
                </button>
            </div>
        </Form>
    </div>
</template>
<style>
#kt_sign_in_submit {
    text-transform: uppercase;
    font-weight: 700;
    letter-spacing: 0.11em;
    font-size: 14px;
    margin-right: 10px;
    padding: 12px;
    height: max-content;
}

.cdr-logo {
    max-width: 100px;
    margin-top: -44px;
}

.cdr-ribbon {
    width: 62px;
    height: 88px;
    margin-left: calc(3rem + 19px);
    background-color: #a78f4f;
}

.login-container {
    padding-left: 3rem;
}

.login-header {
    margin-top: -120px;
    padding-left: 120px;
    letter-spacing: 1px;
}
</style>
<script lang="ts">
import { defineComponent, ref } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";
import usersApi from "@/core/services/UsersApi";

export default defineComponent({
    name: "sign-in",
    components: {
        Field,
        Form,
        ErrorMessage,
    },
    setup() {
        const store = useStore();
        const router = useRouter();

        const submitButton = ref<HTMLElement | null>(null);

        //Create form validation object
        const login = Yup.object().shape({
            email: Yup.string().email().required().label("Email"),
            password: Yup.string().min(4).required().label("Password"),
        });

        //Form submit function
        const onSubmitLogin = (values) => {
            // Clear existing errors
            //store.dispatch(Actions.LOGOUT);

            if (submitButton.value) {
                // Activate indicator
                submitButton.value.setAttribute("data-kt-indicator", "on");
            }

            // Dummy delay
            setTimeout(() => {
                // Send login request
                store
                    .dispatch(Actions.LOGIN, values)
                    .then((res) => {
                        if (res.user.permission.position === 5) {
                            if (res.user.member_id) {
                                router.push({ name: "member-update", params: { member_id: res.user.member_id } });
                            } else {
                                Swal.fire({
                                    text: "Your account does not have the rights to access to the backoffce. Please contact the administrator.",
                                    icon: "error",
                                    buttonsStyling: false,
                                    confirmButtonText: "Ok",
                                    customClass: {
                                        confirmButton: "btn fw-bold btn-light-danger",
                                    },
                                });
                            }
                        } else {
                            router.push({ name: "members-list" });
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        Swal.fire({
                            text: "No active account found with the provided credentials. Either your account wasn't activated or you didn't have any email registered to it. Please contact the administrator to receive an activation link.",
                            icon: "error",
                            buttonsStyling: false,
                            confirmButtonText: "Try again!",
                            customClass: {
                                confirmButton: "btn fw-bold btn-light-danger",
                            },
                        });
                    });

                //Deactivate indicator
                submitButton.value?.removeAttribute("data-kt-indicator");
            }, 500);
        };

        return {
            onSubmitLogin,
            login,
            submitButton,
            router,
        };
    },

    methods: {
        redirectChangePassword() {
            this.router.push({ name: "change-password" });
        },
    },
});
</script>
